import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { sideFormsActions, modalActions } from '../../redux/actions';
import { SideForm } from '../../components/SideForms';

import { ElementItem } from '../../components/Elements';

import {
  RadioButtonGroup,
  RadioButton,
  Form,
  FormGroup,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  NumberInput,
  DatePicker,
  DatePickerInput,
  Toggle,
  Tag,
} from '@carbon/react';
import { CameraAction } from '@carbon/react/icons';
import { Scheduler } from '../../components/Scheduler';
import { hideForm } from '@/redux/new_services/forms';
import { useConfirmClosingForm } from '@/lib/modal';
import StreamItemVariantSwitcher from './StreamItemVariantSwitcher';

import styles from './StreamListItem.module.scss';
import cx from 'classnames';

//const RadioButtonForScheduler = ({ selected = false }) => {
//  return (
//    <>
//      Zeitgesteuert &nbsp; &nbsp;
//      {selected && (
//        <>
//          <Link href="#">auswählen</Link> / <Link href="#">löschen</Link>
//        </>
//      )}
//    </>
//  );
//};

const StreamItemForm = ({ item, orientation, onSave = (_item) => {} }) => {
  const dispatch = useDispatch();
  const [stateItem, setStateItem] = useState({
    element: {
      type: 0,
      s3_med_url: '',
    },
    duration: 0,
    presentation_type: 0,
    interval_duration: 2,
    show_date: false,
    show_date_start: '',
    show_date_end: '',
    items: [],
  });

  console.info('item:', item);

  const isStream = item.element_type === "stream";

  const [unsaved, setUnsaved] = useState(false);
  const confirmClosing = useConfirmClosingForm();

  useEffect(() => {
    setStateItem((state) => ({ ...state, ...item }));
    setUnsaved(false);
  }, [item]);

  const onRequestClose = () => {
    if (unsaved) {
      confirmClosing(() => {dispatch(hideForm())});

    } else {
      dispatch(hideForm())
    }
  };

  const onSaveRequest = () => {
    if (unsaved) {
      onSave(stateItem);
    }
    dispatch(hideForm());
  };

  const changeFormField = (field, value) => {
    let currentItem = stateItem;
    currentItem[field] = value;
    setStateItem({ ...currentItem });
    console.info("changeFormField", field, value);
    console.info(value);
    setUnsaved(true);
  };

  const changeCronSettings = (cron) => {
    if (stateItem.presentation_type === 2) {
      let currentItem = stateItem;
      currentItem.cron = cron;
      setStateItem({ ...currentItem });
      console.info("changeCronSettings");
      setUnsaved(true);
    }
  };

  // Switch the active variant from inside the modal. Mirrors the logic in
  // StreamListItem.setVariantId: pick the variant's media slot that matches
  // the stream orientation (portrait stream → portrait half, landscape →
  // landscape half) so the preview reflects what the device will actually
  // render at runtime.
  const onVariantChange = (variantId) => {
    const group = stateItem._group;
    let nextElement = stateItem.element;
    if (group?.variants) {
      const match = group.variants.find((v) => v.model.ID === variantId);
      if (match) {
        const wantPortrait = orientation === 1;
        nextElement = wantPortrait
          ? (match.portrait_media || match.landscape_media || stateItem.element)
          : (match.landscape_media || match.portrait_media || stateItem.element);
      }
    }
    setStateItem((s) => ({ ...s, variant_id: variantId, element: nextElement }));
    setUnsaved(true);
  };

  return (
    <SideForm
      title={item.element.name}
      subTitle={isStream ? 'Stream anpassen' : 'Element anpassen'}
      onClose={onRequestClose}
      onSubmit={onSaveRequest}
      size="xs"
      primaryButton={'Speichern'}
      primaryButtonDisabled={unsaved === false}
      secondaryButton={unsaved === true ? 'Abbruch' : 'Verlassen'}>
      <div className={cx(styles.itemCard, stateItem.variant_group_id && styles.itemCard_hasVariant)}>
        <div
          style={{
            width: '100%',
            backgroundColor: 'black',
            display: 'flex',
            justifyContent: 'center',
          }}>
          <ElementItem
            url={stateItem.element.s3_med_url}
            orientation={orientation}
            type={stateItem.element.type}
            items={item.element.items || []}
          />
        </div>
        {Boolean(stateItem.element?.pair_id) && (
          <div style={{ padding: '0.5rem 0.75rem' }}>
            <Tag type="cool-gray" renderIcon={CameraAction} size="sm">
              Hoch+Quer-Paar — der Player wählt das Format pro Gerät automatisch
            </Tag>
          </div>
        )}
        {stateItem.variant_group_id && (
          <div className={cx(styles.variantSwitcher)}>
            <StreamItemVariantSwitcher
              groupId={stateItem.variant_group_id}
              inlineGroup={stateItem._group || null}
              variantId={stateItem.variant_id || null}
              onChange={onVariantChange}
            />
          </div>
        )}
      </div>

      <br />
      <Tabs>
        <TabList
          aria-label="Einstellungs-Tabs"
          contained
        >
          <Tab id="tab_default">
            Allgemein
          </Tab>
          <Tab id="tab_presentation_time" disabled={stateItem.presentation_type + 1 !== 3}>
            Zeitsteuerung
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel className="tab-content">
            <Form>
              {isStream || (
                <FormGroup legendText="">
                  <NumberInput
                    step={1}
                    label="Anzeigedauer in Sekunden"
                    allowEmpty={false}
                    id="form_stream_item_visbility"
                    helperText="Die Anzeigedauer die ein Screen auf dem System eingebledet wird."
                    disabled={stateItem.element.type === 1}
                    value={stateItem.duration}
                    invalidText="Der Angegebene Wert ist ungültig!"
                    invalid={
                      stateItem.duration < 1 || stateItem.duration > 5 * 60
                    }
                    onChange={(_e, {value, direction}) => {
                      if (value > 0 ) {
                        changeFormField('duration', Number(value));
                      } else {
                        if (direction) {
                          changeFormField(
                            'duration',
                            direction === 'up'
                              ? stateItem.duration + 1
                              : stateItem.duration - 1
                          );
                        }
                      }

                    }}
                  />
                  <br />
                </FormGroup>
              )}
              <FormGroup legendText="Benutzerdefinierte Gültigkeit">
                <Toggle
                  id="item_show_date"
                  labelA={isStream ? 'Stream immer anzeigen' : 'Element immer anzeigen'}
                  labelB={isStream ? 'Stream nur im Zeitraum anzeigen' : 'Element nur im Zeitraum anzeigen'}
                  labelText={isStream ? 'Zeitraum für Einblendung des Streams' : 'Zeitraum für Einblendung des Elements'}
                  toggled={stateItem.show_date}
                  onToggle={() => {
                    changeFormField('show_date', !stateItem.show_date);
                  }
                  }
                />
                <br />
                {!stateItem.show_date || (
                  <DatePicker
                    id="item_show_datepicker_group"
                    datePickerType="range"
                    dateFormat="d.m.Y"
                    locale="de"
                    short={true}
                    onChange={(e) => {
                      //console.info(e);
                      let s = e[0].toLocaleDateString('en-CA');
                      changeFormField('show_date_start', s);
                      if (e.length > 1) {
                        console.info("e:", e);
                        let t = e[1].toLocaleDateString('en-CA');
                        changeFormField('show_date_end', t);
                      }
                    }}
                    value={[Date.parse(stateItem.show_date_start), Date.parse(stateItem.show_date_end)]}>
                    <DatePickerInput
                      id="item_show_datepicker-start"
                      placeholder="dd.mm.yyyy"
                      labelText="Startdatum"
                      //pattern="\\d{4}-\\d{1,2}-\\d{1,2}"
                      size="md"
                    />
                    <DatePickerInput
                      id="item_show_datepicker-end"
                      placeholder="dd.mm.yyyy"
                      labelText="Enddatum"
                      //pattern="\\d{4}-\\d{1,2}-\\d{1,2}"
                      //pattern="\\d{1,2}.\\d{1,2}.\\d{4}"
                      size="md"
                    />
                  </DatePicker>
                )}
              </FormGroup>
              {isStream || (
                <FormGroup legendText="Darstellungs Steuerung">
                  <RadioButtonGroup
                    legend=""
                    orientation="vertical"
                    name="form_stream_item_visbility"
                    valueSelected={stateItem.presentation_type + 1 || 1}
                    onChange={(e) => changeFormField('presentation_type', e - 1)}>
                    <RadioButton value={1} labelText="Sequentielle Anzeige" />
                    <RadioButton value={2} labelText="Anzeige in Intervallen" />
                    <RadioButton value={3} labelText="Zeitgesteuert Anzeige" />
                  </RadioButtonGroup>
                  {stateItem.presentation_type === 1 && (
                    <NumberInput
                      step={1}
                      label="Interval der Einblendung"
                      allowEmpty={false}
                      id="form_stream_item_interval_duration"
                      helperText={`Wie häufig soll das Element eingeblendet werden? z.B. Nach jedem ${stateItem.interval_duration}. Element`}
                      disabled={stateItem.presentation_type !== 1}
                      value={stateItem.interval_duration || 2}
                      invalidText="Der Angegebene Wert ist ungültig!"
                      invalid={
                        stateItem.interval_duration < 2 ||
                        stateItem.interval_duration > 10
                      }
                      onChange={(_e, {value, direction}) => {
                        if (value > 0) {
                          changeFormField(
                            'interval_duration',
                            Number(value)
                          );
                        } else {
                          if (direction) {
                            changeFormField(
                              'interval_duration',
                              direction === 'up'
                                ? stateItem.interval_duration + 1
                                : stateItem.interval_duration - 1
                            );
                          }
                        }
                      }}
                    />
                  )}
                </FormGroup>
              )}

            </Form>
          </TabPanel>
          <TabPanel className="tab-content">
            <Scheduler value={stateItem.cron} onChange={changeCronSettings} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </SideForm>
  );
};

export default StreamItemForm;
